<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M10 2.8 2.8 6.6 10 10.4l7.2-3.8z"/><path d="M2.8 10.4 10 14.2l7.2-3.8M2.8 13.8 10 17.6l7.2-3.8"/></svg>
</template>
